import React from 'react';
import { ModalTitleView } from '../../common/components';
export default [
    {
        key: 'AddTenantModal',
        getComponent: function () { return import('./AddTenantModal'); },
        width: 700,
        title: '',
        maskClosable: false,
        timeout: 500,
    },
    {
        key: 'CorporationInitializeModal',
        getComponent: function () { return import('./CorporationInitializeModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'CorporationInitializeConfirmModal',
        getComponent: function () { return import('./CorporationInitializeConfirmModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
    },
    {
        key: 'AddVirtualDepartmentModal',
        getComponent: function () { return import('./AddVirtualDepartmentModal'); },
        width: 600,
        maskClosable: false,
        wrapClassName: 'vertical-center-modal',
        title: (React.createElement(ModalTitleView, { className: "modal-title-vertical", title: i18n.get('创建虚拟部门'), subTitle: i18n.get('虚拟部门，可作为挂靠部门子部门的根节点使用，且不会改变通讯录结构') })),
    },
];
